import clsx from 'clsx';
import styles from './Badge.module.scss';
import {useStationData} from '@/stores/channel/station';

const BadgeInfo = () => {
  const {station} = useStationData();

  const badges = station.badges;

  if (!badges || badges.length === 0) {
    return null;
  }

  return (
    <div className={styles.badgeWrap}>
      {badges
        .filter((badge) => badge.groupClassName)
        .slice(0, 3)
        .map((badge, idx) => {
          return (
            <span
              key={idx}
              className={clsx(styles[badge.groupClassName || ''])}
              style={{backgroundColor: badge.groupBackgroundColor}}>
              {badge.groupName}
            </span>
          );
        })}
    </div>
  );
};

export default BadgeInfo;
